import React, { useState, useEffect } from "react";
import LogoLockup from "./icons/LogoLockup.jsx";
import Arrow from "./icons/Arrow.jsx";
import { NAV } from "../pages/registry.js";

const Nav = ({ page, go }) => {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 14);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const nav = (p) => { setOpen(false); go(p); };
  return (
    <header className={"nav" + (solid ? " solid" : "")}>
      <div className="wrap nav-in">
        <div className="brand" onClick={() => nav("home")} role="button" tabIndex={0}
             onKeyDown={(e) => e.key === "Enter" && nav("home")} aria-label="A4 Express — home">
          <LogoLockup variant="dark" />
        </div>
        <nav className="nav-links" aria-label="Main">
          {NAV.map(([k, l]) => (
            <button key={k} className={"nav-link" + (page === k ? " active" : "")}
                    aria-current={page === k ? "page" : undefined} onClick={() => nav(k)}>{l}</button>
          ))}
          <button className="btn btn-primary nav-cta" onClick={() => nav("contact")}>Request a quote</button>
        </nav>
        <button className={"burger" + (open ? " open" : "")} onClick={() => setOpen(!open)}
                aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open}><span /></button>
      </div>
      {open && (
        <div className="mobile">
          <div className="wrap mobile-in">
            {NAV.map(([k, l]) => <button key={k} onClick={() => nav(k)}>{l}</button>)}
            <button className="btn btn-primary" onClick={() => nav("contact")}>Request a quote <Arrow /></button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
